import { styled } from "@mui/material/styles";
import { Box, Button, Typography, Card, Stack } from "@mui/material";
import { APP_COLORS, APP_FONT_FAMILIES } from "../../../../enums";
import FlexBox from "../../../../components/layouts/Flexbox";

export const ThumbnailBox = styled(Box)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  height: 250,
  width: "100%",
  maxWidth: 320,
  margin: "0 auto",
  [theme.breakpoints.up("sm")]: {
    width: 320,
    margin: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

export const ThumbnailImg = styled("img")<{ $loaded?: boolean }>(
  ({ $loaded }) => ({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: $loaded ? 1 : 0,
    borderRadius: 16,
  })
);

export const ThumbnailPlaceholder = styled("img")({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

export const PlayRecordingButton = styled(Button)({
  position: "absolute",
  bottom: 16,
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  color: APP_COLORS.white,
  fontWeight: 600,
  textTransform: "none",
  borderRadius: 16,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    color: APP_COLORS.textDark,
  },
  "& .MuiButton-startIcon": {
    color: "inherit",
  },
});

export const DetailRow = styled(FlexBox)({
  alignItems: "center",
  gap: 12,
});

export const DetailText = styled(Typography)({
  color: APP_COLORS.textDark,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
});

export const DetailsStack = styled(FlexBox)({
  flexDirection: "column",
  gap: 12,
  flex: 1,
});

export const DownloadButtonsStack = styled(Stack)({
  gap: 12,
  marginTop: "auto",
});

export const DownloadButton = styled(Button)({
  backgroundColor: APP_COLORS.greyLight2,
  color: APP_COLORS.textDark,
  fontWeight: 600,
  textTransform: "none",
  borderRadius: 12,
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
  justifyContent: "flex-start",
  padding: "10px 16px",
  "&:hover": {
    backgroundColor: APP_COLORS.greyLight3,
  },
  "& .MuiButton-startIcon": {
    color: APP_COLORS.greyDark2,
  },
});

export const SummarySection = styled(Box)({
  marginTop: 16,
});

export const SummaryHeader = styled(FlexBox)({
  justifyContent: "flex-end",
  marginBottom: 8,
});

export const SummaryTitle = styled(Typography)({
  textAlign: "center",
  fontWeight: "bold",
  fontSize: 24,
});
